import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppProvider from "./AppProvider";
import SignInPage from "./pages/signin/SignInPage";
import MainPage from "./pages/main/MainPage";
import SignUpPage from "./pages/signup/SignUpPage";
import AccessDeniedPage from "./pages/denied";
import Queue from "nq";
import RedirectPage from "./pages/RedirectPage";
import TestPage from "./pages/TestPage";
import TenantPage from "./pages/TenantPage";
import Calculator from "./pages/Calc";
import Test from "./pages/Test";

Queue.setUrl("https://api.innque.com/v1");
// Queue.setUrl("http://174.138.20.51/v1");
// Queue.setUrl("http://152.42.234.10/v1");
// Queue.setUrl("http://159.223.64.52/v1");
// Queue.setUrl("http://146.190.95.27/v1");
// Queue.setUrl("http://167.99.76.91/v1");

Queue.setApplicationId("bc29547f-8ffd-4221-9d70-d4e68c158623");

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/test" element={<TestPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/signin/:masterKey" element={<SignInPage />} />
          <Route path="/signup" element={<SignUpPage />} />
          <Route path="/redirect/:id" element={<RedirectPage />} />
          <Route path="/app" element={<TenantPage />} />
          <Route path="/*" element={<MainPage />} />
          <Route path={"/denied"} element={<AccessDeniedPage />} />
          <Route path="/calc" element={<Calculator />} />
          <Route path="/speech" element={<Test />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
